import { Select as ChakraReactSelect } from 'chakra-react-select';
import keyBy from 'lodash/keyBy';

/**
 * @deprecated: Use ComboxBoxInput from "@springcare/sh-component-library"
 */
export const Select = ({ options, value, onChange, ...rest }) => {
  const optionsDictionary = keyBy(options, 'value');

  return (
    <ChakraReactSelect
      value={value ? optionsDictionary[value] : undefined}
      onChange={(option) => {
        onChange(option?.value);
      }}
      options={options}
      inputId={rest.inputId || rest.name}
      {...rest}
      isMulti={false}
      chakraStyles={{
        menu: (provided) => ({
          ...provided,
          overflow: 'visible',
        }),
        control: (provided) => ({
          ...provided,
          backgroundColor: 'background-base',
        }),
      }}
    />
  );
};
